import { apiV4 } from './utils';
import analytics from '../utils/analytics';

const getSubscriptionUrl = (type: string) => `/email/subscription/${type}`;

export const abandonCart = ({
  email,
  firstName,
  lastName,
  cartId,
  partnerId,
  quizData,
}: {
  email: string;
  firstName: string;
  lastName: string;
  cartId: string;
  partnerId: string;
  quizData: Object;
}) =>
  apiV4({
    method: 'POST',
    url: getSubscriptionUrl('abandon-cart-new'),
    body: {
      email,
      firstName,
      lastName,
      cartId,
      partnerId,
      quizData,
    },
  }).then((res) => {
    analytics.identify({
      email,
      cartId,
    });
    return res;
  });

export const unavailableZip = ({
  email,
  postalCode,
  cartId,
  partnerId,
}: {
  email: string;
  postalCode: string;
  cartId: string;
  partnerId: string;
}) =>
  apiV4({
    method: 'POST',
    url: getSubscriptionUrl('unavailable-zip'),
    body: {
      email,
      postalCode,
      cartId,
      partnerId,
    },
  }).then((res) => {
    analytics.identify({
      email,
      cartId,
    });
    return res;
  });

export const sendSavedCart = ({
  email,
  cartId,
  partnerId,
  quizData,
}: {
  email: string;
  cartId: string;
  partnerId: string;
  quizData: Object;
}) =>
  apiV4({
    method: 'POST',
    url: getSubscriptionUrl('saved-cart-new'),
    body: {
      email,
      cartId,
      partnerId,
      quizData,
    },
  }).then((res) => {
    analytics.identify({
      email,
      cartId,
    });
    return res;
  });

export const contact = ({
  email,
  subject,
  name,
  message,
  cartId,
  partnerId,
}: {
  email: string;
  subject: string;
  name: string;
  message: string;
  cartId: string;
  partnerId: string;
}) =>
  apiV4({
    method: 'POST',
    url: getSubscriptionUrl('contact'),
    body: {
      email,
      subject,
      name,
      body: message,
      cartId,
      partnerId,
    },
  }).then((res) => {
    analytics.identify({
      email,
      cartId,
    });
    return res;
  });

export const rightToKnow = ({
  requestType,
  firstName,
  lastName,
  email,
  address,
}: {
  requestType: string;
  firstName: string;
  lastName: string;
  email: string;
  address: string;
}) =>
  apiV4({
    method: 'POST',
    url: '/right-to-know',
    body: { requestType, firstName, lastName, email, address },
  }).then((res) => {
    analytics.identify({
      email,
    });
    return res;
  });

export const signup = ({
  email,
  cartId,
  partnerId,
}: {
  email: string;
  cartId?: string;
  partnerId?: string | null;
}) =>
  apiV4({
    method: 'POST',
    url: getSubscriptionUrl('general'),
    body: {
      email,
      cartId,
      partnerId,
    },
  }).then((res) => {
    analytics.identify({
      email,
      cartId,
    });
    analytics.track('sign_up', {
      email,
      cartId,
      ecommerce: {
        method: partnerId,
      },
    });
    return res;
  });

export const customerInfoSignup = ({
  email,
  cartId,
  partnerId,
}: {
  email: string;
  cartId: string;
  partnerId: string;
}) =>
  apiV4({
    method: 'POST',
    url: getSubscriptionUrl('customer-info'),
    body: {
      email,
      cartId,
      partnerId,
    },
  }).then((res) => {
    analytics.identify({
      email,
      cartId,
    });
    analytics.track('sign_up', {
      email,
      cartId,
      ecommerce: {
        method: partnerId,
      },
    });
    return res;
  });

export const bannerOffer = ({
  email,
  cartId,
  partnerId,
}: {
  email: string;
  cartId: string;
  partnerId?: string;
}) =>
  apiV4({
    method: 'POST',
    url: getSubscriptionUrl('banner-offer-new'),
    body: { email, cartId, partnerId },
  }).then((res) => {
    analytics.identify({
      email,
      cartId,
    });
    analytics.track('sign_up', {
      email,
      cartId,
      ecommerce: {
        method: partnerId,
      },
    });
    return res;
  });

export const saveQuizEmail = ({
  cartId,
  email,
  quizVersion,
}: {
  cartId: string;
  email: string;
  quizVersion: string;
}) =>
  apiV4({
    method: 'POST',
    url: getSubscriptionUrl('quiz-capture'),
    body: {
      cartId,
      email,
      quizCaptureVersion: quizVersion,
    },
  }).then((res) => {
    analytics.identify({
      email,
      cartId,
    });
    analytics.track('sign_up', {
      email,
      cartId,
    });
    return res;
  });

export const downloads = ({
  email,
  cartId,
}: {
  email: string;
  cartId: string;
}) =>
  apiV4({
    method: 'POST',
    url: getSubscriptionUrl('downloads'),
    body: {
      email,
      cartId,
    },
  }).then((res) => {
    analytics.identify({
      email,
      cartId,
    });
    return res;
  });

export const recentPurchases = () =>
  apiV4({
    method: 'GET',
    url: `/recent-purchases`,
  });

export const scholarshipSubmission = (body: Object) =>
  apiV4({
    method: 'POST',
    url: `/scholarship-submission`,
    body,
  });

/**
 *
 * @param {object} body
 * @returns
 */
export const scholarshipEmailConfirmation = (body: Object) =>
  apiV4({
    method: 'POST',
    url: `/scholarship-email`,
    body,
  });

export const requestQuote = (body: Object) =>
  apiV4({
    method: 'POST',
    url: `/email/subscription/quote-form`,
    body,
  });

export const verifyPerkspotStatus = ({
  email,
  cartId,
}: {
  email: string;
  cartId: string;
}) =>
  apiV4({
    method: 'POST',
    url: getSubscriptionUrl('perkspot'),
    body: {
      email,
      cartId,
    },
  });
